import LogoMain from "../assets/logo_main.svg";
import Logo from "../assets/logo.svg";
import AvatarProfile from "../assets/default_avatar.png";
import Notification from "../assets/notifications.svg";
import EditIcon from "../assets/edit_icon.svg";
import Badge from "../assets/Badges.svg";
import Frame from "../assets/Frame.jpg";
import BackgroundCustomerSite from "../assets/background_customers_site.jpg";
import IconShowPassword from "../assets/ic_show_password.svg";
import IconHidePassword from "../assets/ic_hide_password.svg";
import IconError from "../assets/ic_error.svg";
import IconCheckOK from "../assets/ic_check_ok.svg";
import IconCheckError from "../assets/ic_check_error.svg";
import IconCheckInit from "../assets/ic_check_init.svg";
import IconMinus from "../assets/ic_minus.svg";
import IconPlus from "../assets/ic_plus.svg";
import IconX from "../assets/ic_x.svg";
import LogoLetterCustomerSite from "../assets/logo_letter_customers_site.svg";
import LogoIconCustomerSite from "../assets/logo_icon_customers_site.svg";
import LogoutIconCustomerSite from "../assets/log_out.svg";
import IconInProduction from "../assets/ic_in_production.svg";
import IconReady from "../assets/ic_ready.svg";
import IconDelivered from "../assets/ic_delivered.svg";
import IconCompleted from "../assets/ic_completed.svg";
import IconUIConfig from "../assets/ic_ui_config.svg";
import IconMenu from "../assets/ic_menu.svg";
import IconLogoutForMobile from "../assets/ic_logout_mobile.svg";
import IconDragAndDrop from "../assets/ic-drag-drop.svg";
import IconBack from "../assets/ic_back.svg";
import IconSearch from "../assets/ic_search.svg";
import IconDownload from "../assets/ic_download.svg";
import IconFilter from "../assets/ic_filter.svg";
import IconFilterMobile from "../assets/ic_filter_mobile.svg";
import IconViewMoreMobile from "../assets/ic_view_more_mobile.svg";
import IconViewLessMobile from "../assets/ic_view_less_mobile.svg";
import IconToastSuccessed from "../assets/ic_toast_successed.svg";
import IconToastFailed from "../assets/ic_toast_failed.svg";
import IconCsvMobile from "../assets/ic_csv_mobile.svg";
import IconDocument from "../assets/ic_document.svg";
import IconCalendarLeft from "../assets/ic_calendar_l.svg";
import IconCalendarRight from "../assets/ic_calendar_r.svg";
import IconCalendarMobile from "../assets/ic_calendar_mobile.svg";

export const Images = {
  IconDragAndDrop,
  LogoMain,
  Logo,
  AvatarProfile,
  Notification,
  EditIcon,
  Badge,
  Frame,
  BackgroundCustomerSite,
  IconShowPassword,
  IconHidePassword,
  IconError,
  IconCheckOK,
  IconCheckError,
  IconCheckInit,
  IconMinus,
  IconPlus,
  IconX,
  LogoLetterCustomerSite,
  LogoIconCustomerSite,
  LogoutIconCustomerSite,
  IconLogoutForMobile,
  IconInProduction,
  IconReady,
  IconDelivered,
  IconCompleted,
  IconUIConfig,
  IconMenu,
  IconBack,
  IconSearch,
  IconDownload,
  IconFilter,
  IconFilterMobile,
  IconViewMoreMobile,
  IconViewLessMobile,
  IconToastSuccessed,
  IconToastFailed,
  IconCsvMobile,
  IconDocument,
  IconCalendarLeft,
  IconCalendarRight,
  IconCalendarMobile
};
